// import React from 'react';
// import './partners.css';

// // Import images at the top
// import certifiedPartnerImage from '../../img/des_sec/partner_1.svg';
// import innovationPartnerImage from '../../img/des_sec/partner_2.svg'; 
// import technologyPartnerImage from '../../img/des_sec/partner_3.svg';

// const Partnerbenefits = () => {
//   return (
//     <div className="partnership-container">
//       <h2 className="partnership-title">A Partnership Built for Success</h2>
      
//       <p className="partnership-description">
//         Honored to be UKG's #1 ranked partner, recognized for our expertise in Implementation,
//         Technology, and Innovation and delivering cutting-edge workforce solutions with excellence.
//       </p>
      
//       <div className="badges-container">
//         <div className="badge-item">
//           <img 
//             src={certifiedPartnerImage} 
//             alt="UKG Certified Implementation Partner" 
//             className="badge-image"
//           />
//         </div>
        
//         <div className="badge-item">
//           <img 
//             src={innovationPartnerImage} 
//             alt="UKG Innovation Partner 2023" 
//             className="badge-image"
//           />
//         </div>
        
//         <div className="badge-item">
//           <img 
//             src={technologyPartnerImage} 
//             alt="UKG Certified Technology partner" 
//             className="badge-image"
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Partnerbenefits;

import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './partner_benefits.css';

// Import images at the top
import certifiedPartnerImage from '../../img/pb_1.svg';
import innovationPartnerImage from '../../img/pb_2.svg'; 
import technologyPartnerImage from '../../img/pb_3.svg';
import pb4 from '../../img/des_sec/pb_4.svg';
import pb5 from '../../img/des_sec/pb_5.svg';

const Partnerbenefits = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Animation for title
  const titleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(30px)',
    config: { 
      tension: 200, 
      friction: 40,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for description
  const descriptionAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(25px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 250 : 0
  });

  // Animation for badges container
  const badgesContainerAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1
    },
    delay: inView ? 400 : 0
  });

  // Individual badge animations with staggered delays
  const badge1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(15px) scale(0.95)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 550 : 0
  });

  const badge2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(15px) scale(0.95)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 650 : 0
  });

  const badge3Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(15px) scale(0.95)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 750 : 0
  });

  return (
    <div className="partnership-container-pb" ref={containerRef}>
      <animated.h2 
        className="partnership-title-pb"
        style={titleAnimation}
      >
        Benefits of Partnering with VYN
      </animated.h2>
      
      <animated.p 
        className="partnership-description-pb"
        style={descriptionAnimation}
      >
        Accelerate your business growth with VYN’s cutting-edge workforce management platform. Gain access to powerful tools, ready-to-use resources, and a network built for innovation—so you can deliver more value, faster.
      </animated.p>
      
      <animated.div 
        className="badges-container-pb"
        style={badgesContainerAnimation}
      >
        <animated.div 
          className="badge-item-pb"
          style={badge1Animation}
        >
          <img 
            src={certifiedPartnerImage} 
            alt="UKG Certified Implementation Partner" 
            className="badge-image-pb"
          />
        </animated.div>
        
        <animated.div 
          className="badge-item-pb"
          style={badge2Animation}
        >
          <img 
            src={innovationPartnerImage} 
            alt="UKG Innovation Partner 2023" 
            className="badge-image-pb"
          />
        </animated.div>
        
        <animated.div 
          className="badge-item-pb"
          style={badge3Animation}
        >
          <img 
            src={technologyPartnerImage} 
            alt="UKG Certified Technology partner" 
            className="badge-image-pb"
          />
        </animated.div>
        <animated.div 
          className="badge-item-pb"
          style={badge3Animation}
        >
          <img 
            src={pb5} 
            alt="UKG Certified Technology partner" 
            className="badge-image-pb"
          />
        </animated.div>
        <animated.div 
          className="badge-item-pb"
          style={badge3Animation}
        >
          <img 
            src={pb4} 
            alt="UKG Certified Technology partner" 
            className="badge-image-pb"
          />
        </animated.div>
      </animated.div>
    </div>
  );
};

export default Partnerbenefits;